import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";
import { SURQUAL_LOS_PAGE } from "./SURQUAL_LOS";

export const MAPPING_LOS_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "LOS",
  menuLabel: "LOS",
  pageLabel: "LOS_TITLE_MAPPING",
  name: "mapping_los",
  path: "los",
  description: "CONF_DESC_MAPPING_LOS",
  model: {
    entityName: "datafeed",
    label: "LOS",
    path: "/api/mapping/los",
    bulkPath: "/api/mapping/los/bulk-updates",
    name: "mapping_los",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "los.short_name",
        order: 2,
        label: "LOS",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/los/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/los/export" },
    import: { path: "/api/mapping/los/presign-url" },
  },
  // Options pour le tableau de la page
  options: {
    formFields: [
      {
        key: "datafeed",
        label: "DATA_FEED_CODE",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/los/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "los",
        label: "LOS",
        labelKey: "short_name",
        subCreationForm: SURQUAL_LOS_PAGE,
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "los",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "los",
        flex: "100%",
      },
    ],
  },
};
